import type { CtaButton } from './supabase-types';

export type CtaSheetKind = 'frame' | 'card';

/**
 * Every CTA button opens the in-page sheet; what is in it depends on the site:
 * the site itself when the portal's check found it allows framing, otherwise
 * a preview card with one link out — never a frame that might stay blank, so
 * an unchecked site (null) is a card too.
 */
export function ctaSheetKind(b: Pick<CtaButton, 'embeddable'>): CtaSheetKind {
  return b.embeddable === true ? 'frame' : 'card';
}

/** The club may type a bare host; without a scheme the browser would treat it as a path. */
export function ctaHref(raw: string): string {
  const url = raw.trim();
  return /^https?:\/\//i.test(url) ? url : `https://${url}`;
}

/** The site's name as fans know it: the host without www. */
export function hostOf(url: string): string {
  try { return new URL(url).hostname.replace(/^www\./, ''); } catch { return url; }
}
